import CompanyDisallowed from './CompanyDisallowed';
export default CompanyDisallowed;
